import { createChatSocketTicket } from 'store/chat/services/createChatSocketTicket.service';

/**
 * The URL to open the chat WebSocket with: the configured one plus a ticket
 * the API minted for the signed-in user.
 *
 * The chat socket cannot take a SigV4 signature the way the project email and
 * Nerobotti sockets do: the external app's meeting guests connect to it too,
 * and have no AWS credentials, so its $connect is checked by its own lambda
 * rather than by an IAM authorizer. A signed-in user proves who they are to
 * the IAM-authorized REST API instead, which answers with a ticket. A ticket
 * opens one connection, so useWebSocket fetches a fresh one on every attempt.
 *
 * Without a ticket this answers with the bare URL rather than failing: the
 * socket that predates tickets ignores them, and this frontend ships before it
 * is replaced. The new socket refuses a bare URL, and useWebSocket retries.
 *
 * @param {string} url e.g. `REACT_APP_CHAT_WEBSOCKET_URL`
 * @returns {Promise<string>}
 */
export const createChatSocketUrl = async (url) => {
  try {
    const { ticket } = (await createChatSocketTicket()) || {};

    if (!ticket) {
      throw new Error('The API answered without a ticket');
    }

    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}ticket=${encodeURIComponent(ticket)}`;
  } catch (error) {
    console.error('[createChatSocketUrl] No chat socket ticket:', error);
    return url;
  }
};

export default createChatSocketUrl;
